import { BehaviorSubject } from 'rxjs';

/*
 * Holds and manages the app's current timezone.
 *
 * setTimezone() updates the timezone.
 * getTimezone() returns the current timezone value.
 */
export class TimezoneStore {
  static tz = new BehaviorSubject<string>(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  static getTimezone = () => TimezoneStore.tz.getValue();

  static setTimezone(tz: string) {
    TimezoneStore.tz.next(tz?.split(' ')[0]);
  }
}